/* ChewNectar v5/v6/v7/v8 "Color Journey". No dependencies. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isHome = document.body.classList.contains('template-index');
  const isProduct = document.body.classList.contains('template-product');
  /* Collection pages run the same reveal and journey-bar motion as the homepage.
     Without this the whole cascade is simply absent there: measured 0 revealed
     elements on /collections/kids-gummies before this line existed. */
  const isCollection = document.body.classList.contains('template-collection');
  const isJourney = isHome || isCollection;

  /* 1. Cursor-aware hover invert: the dark fill grows from the point the pointer enters,
        and retreats toward the point it leaves. CSS reads --px / --py. */
  const setPoint = (e) => {
    const b = e.target.closest && e.target.closest('.btn');
    if (!b) return;
    const r = b.getBoundingClientRect();
    b.style.setProperty('--px', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
    b.style.setProperty('--py', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
  };
  document.addEventListener('pointerover', setPoint, { passive: true });
  document.addEventListener('pointerout', setPoint, { passive: true });

  const parse = (str) => {
    str = (str || '').trim();
    let m = str.match(/^#([0-9a-f]{3,8})$/i);
    if (m) {
      let h = m[1];
      if (h.length === 3) h = h.split('').map((x) => x + x).join('');
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }
    m = str.match(/rgba?\((\d+)[ ,]+(\d+)[ ,]+(\d+)/i);
    return m ? [+m[1], +m[2], +m[3]] : null;
  };
  const lum = (c) => {
    const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
  };
  const whiteContrast = (rgb) => 1.05 / (lum(rgb) + 0.05);

  /* 2. Scroll reveal with stagger inside grids */
  if (isJourney) {
    document.querySelectorAll('.cn-section > .wrap > *, .cn-wg .wrap > *, .cn-dr .cn-dr__box').forEach((el) => {
      el.setAttribute('data-reveal', '');
    });
    document.querySelectorAll('.pgrid > *, .jneeds__row > *, .tgrid > *, .inside > *, .guide > *, .docs__grid > *, .cn-ci__chips > *').forEach((el, i) => {
      el.style.setProperty('--rd', String(i % 6));
    });
  }
  if (isProduct) {
    document.querySelectorAll('.pwhy > *, .pnut > *, .ptl > li, .pgrid > *, .prev__steps > li').forEach((el, i) => {
      el.style.setProperty('--rd', String(i % 5));
    });
  }
  /* Everything carrying the attribute gets observed, whether this script added it or
     a section wrote it in its own markup. Nothing is ever left at opacity zero. */
  const targets = Array.from(document.querySelectorAll('[data-reveal]'));
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    targets.forEach((el) => io.observe(el));
  }
  /* Safety net: nothing stays invisible if the observer never fires. */
  window.setTimeout(() => targets.forEach((el) => el.classList.add('is-in')), 2500);

  if (isJourney || isProduct) {
    /* 3. Journey bar. On the homepage and collection pages it cycles the four brand
          colours as each zone passes the middle of the viewport. On a product page it
          stays that product's colour. */
    const bar = document.createElement('div');
    bar.className = 'jbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<i></i>';
    document.body.appendChild(bar);
    if (isProduct) {
      bar.style.setProperty('--jbar', 'var(--c)');
    } else {
      const cycle = ['--m-pink', '--m-orange', '--m-purple', '--m-blue'];
      const zones = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
      if ('IntersectionObserver' in window) {
        const so = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            const i = zones.indexOf(en.target);
            bar.style.setProperty('--jbar', 'var(' + cycle[(i < 0 ? 0 : i) % 4] + ')');
          });
        }, { rootMargin: '-48% 0px -50% 0px' });
        zones.forEach((z) => so.observe(z));
      }
    }
  }

  if (isHome) {
    /* 4. Guardians section can take the colour of the selected product.

          This only happens when the merchant has left the section's own background
          colour blank. A colour chosen in the theme editor always wins, otherwise the
          section would silently ignore the setting and break the page's colour order.
          Event-driven (no MutationObserver) so it can never fight the theme's own
          spotlight script. */
    const spot = document.querySelector('.cn-section.spot');
    if (spot) {
      const chosen = getComputedStyle(spot).getPropertyValue('--sec-bg').trim();
      const follow = spot.dataset.followProduct === 'true' || chosen === '' || chosen === 'transparent';
      if (follow) {
        const apply = () => {
          const sel = spot.querySelector('.gbtn[aria-selected="true"]');
          if (!sel) return;
          const c = getComputedStyle(sel).getPropertyValue('--c').trim();
          const rgb = parse(c);
          if (!rgb) return;
          const text = whiteContrast(rgb) >= 4.5 ? '#ffffff' : '#1E1026';
          spot.style.setProperty('--sec-bg', c);
          spot.style.setProperty('--sec-text', text);
          spot.style.setProperty('--ink', text);
          spot.style.setProperty('--muted', 'color-mix(in srgb, ' + text + ' 84%, transparent)');
        };
        const later = () => window.requestAnimationFrame(() => window.requestAnimationFrame(apply));
        spot.addEventListener('click', later);
        spot.addEventListener('keyup', later);
        later();
      }
    }
  }

  /* 5. Hero: cascading scenes, product-colour background, cursor parallax, touch swipe */
  if (!customElements.get('cn-journey-hero')) {
    class CnJourneyHero extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.jh');
        this.scenes = Array.from(this.querySelectorAll('.jh__scene'));
        this.dots = Array.from(this.querySelectorAll('.jh__dot'));
        this.pauseBtn = this.querySelector('.jh__pause');
        this.index = 0;
        this.interval = (parseInt(this.dataset.interval, 10) || 7) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce && this.scenes.length > 1;
        this.userPaused = false;
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));
        if (this.pauseBtn) {
          if (!this.autoplay) this.pauseBtn.hidden = true;
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseBtn.textContent = this.userPaused ? this.pauseBtn.dataset.play : this.pauseBtn.dataset.pause;
            if (this.userPaused) this.stop(); else this.start();
          });
        }
        this.addEventListener('focusin', () => this.stop(), { passive: true });
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); else this.start(); });
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.scenes.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i > -1) { this.stop(); this.go(i, false); }
        });
        if (!reduce) {
          let raf = 0;
          this.addEventListener('pointermove', (e) => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = 0;
              const r = this.getBoundingClientRect();
              this.style.setProperty('--mx', (((e.clientX - r.left) / r.width) - 0.5).toFixed(3));
              this.style.setProperty('--my', (((e.clientY - r.top) / r.height) - 0.5).toFixed(3));
            });
          }, { passive: true });
        }
        this.bindSwipe();
        this.set(0);
        this.start();
      }

      /* Touch swipe. The scenes crossfade rather than scroll sideways, so there is
         nothing to drag along with the finger: a horizontal flick calls the same go()
         the dots call, which keeps one slider engine rather than two. Both listeners
         are passive and never call preventDefault, so a vertical drag still scrolls
         the page exactly as it did before. */
      bindSwipe() {
        if (this.scenes.length < 2) return;
        let sx = 0, sy = 0, st = 0, live = false;
        this.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) { live = false; return; }
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          st = Date.now();
          live = true;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (!live) return;
          live = false;
          const t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          const dx = t.clientX - sx;
          const dy = t.clientY - sy;
          if (Date.now() - st > 600) return;
          if (Math.abs(dx) < 45) return;
          if (Math.abs(dx) < Math.abs(dy) * 1.4) return;
          this.go(this.index + (dx < 0 ? 1 : -1), true);
        }, { passive: true });
      }

      disconnectedCallback() { this.stop(); }
      go(i, fromUser) {
        const n = this.scenes.length;
        this.set(((i % n) + n) % n);
        if (fromUser) { this.stop(); if (!this.userPaused) this.start(); }
      }
      set(i) {
        this.index = i;
        this.scenes.forEach((s, k) => {
          const on = k === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          s.querySelectorAll('a,button').forEach((el) => { el.tabIndex = on ? 0 : -1; });
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        const s = this.scenes[i];
        if (this.root && s) {
          this.root.style.setProperty('--jc', s.dataset.color);
          this.root.style.setProperty('--jt', s.dataset.tone === 'dark' ? '#1E1026' : '#ffffff');
          this.root.dataset.tone = s.dataset.tone || 'light';
        }
      }
      start() {
        if (!this.autoplay || this.userPaused || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
    }
    customElements.define('cn-journey-hero', CnJourneyHero);
  }
})();
